import { Link, useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { AGENTS } from "./_partials/agents.data";
import AgentSidebar from "./_partials/AgentSidebar";
import AgentLaunchCard from "./_partials/AgentLaunchCard";

export default function AgentPage() {
  const { id } = useParams();
  const agent = AGENTS[id];

  // Per-page meta tags + OG image for richer LinkedIn/iMessage previews
  useDocumentMeta({
    title: agent
      ? `${agent.name} · ${agent.role} — Integrated Clinical Intelligence`
      : "Integrated Clinical Intelligence",
    description: agent ? agent.blurb : "",
    image: agent
      ? agent.avatar ||
        "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/o9zd7w6y_8OhA8LIoIvTWX4h8aiJ8C%20%281%29.png"
      : null,
  });

  // Other agents (exclude the current one) — cheap filter, no need to memoize
  const otherAgents = agent
    ? Object.values(AGENTS).filter((a) => a.id !== agent.id)
    : [];

  if (!agent) return <Navigate to="/" replace />;

  return (
    <div data-testid={`agent-page-${agent.id}`} className="min-h-screen bg-background">
      <Header />
      <main className="pt-24 md:pt-28 pb-16 md:pb-20">
        <section className="max-w-7xl mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-7"
          >
            <Link
              to="/"
              data-testid="agent-back-link"
              className="eyebrow inline-flex items-center gap-2 text-foreground/65 hover:text-primary transition-colors"
            >
              <span aria-hidden>←</span> Back to Integrated Clinical Intelligence
            </Link>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
            <AgentSidebar agent={agent} otherAgents={otherAgents} />
            <AgentLaunchCard agent={agent} />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
